import { render, staticRenderFns } from "./beneficial-ownership-1071-status-badge.vue?vue&type=template&id=b22b733c&"
import script from "./beneficial-ownership-1071-status-badge.vue?vue&type=script&lang=ts&"
export * from "./beneficial-ownership-1071-status-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports